import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className='flex items-center justify-center py-12'>
      <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600'></div>
    </div>
  );
};

export default LoadingSpinner;
